import { SVGProps, Ref, forwardRef } from 'react';

export const PlusOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.3 7.3V3h1.4v4.3H13v1.4H8.7V13H7.3V8.7H3V7.3z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlusOutlinedSize16Glyph.displayName = 'PlusOutlinedSize16Glyph';
